import React from 'react';
import PropTypes from 'prop-types';
import Pagination from '../Pagination';
import { filterRecordsByPage } from '../../selectors/selectors';
import formatColumnValue from '../../utils/formatColumnValue';

const UsageTablePerMonth = ({ records, activePage, paginate }) => {
  const paginated = filterRecordsByPage(records, activePage);

  return (
    <div>
      {records.length > 0
        ? <Pagination
            activePage={activePage}
            pageCount={paginated.pageCount}
            pageSelect={paginate}
          >
            <table className="table table-fixed">
              <thead>
                <tr>
                  <th>Month</th>
                  <th className="hide-for-mobiles">Social</th>
                  <th className="hide-for-mobiles">Password</th>
                  <th className="hide-for-mobiles">Passwordless</th>
                  <th className="hide-for-mobiles">Enterprise</th>
                  <th>Total Active</th>
                </tr>
              </thead>
              <tbody>
                {paginated.recordsByPage.map(record =>
                  <tr key={record.month}>
                    <td>
                      {formatColumnValue('month', record)}
                    </td>
                    <td className="hide-for-mobiles">
                      {formatColumnValue('users_social', record)}
                    </td>
                    <td className="hide-for-mobiles">
                      {formatColumnValue('users_password', record)}
                    </td>
                    <td className="hide-for-mobiles">
                      {formatColumnValue('users_passwordless', record)}
                    </td>
                    <td className="hide-for-mobiles">
                      {formatColumnValue('users_enterprise', record)}
                    </td>
                    <td>
                      {formatColumnValue('active_users', record)}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Pagination>
        : <div className="empty-records">
            <p>There are no usage statistics at this time.</p>
          </div>}
    </div>
  );
};

UsageTablePerMonth.propTypes = {
  paginate: PropTypes.func.isRequired,
  activePage: PropTypes.number.isRequired,
  records: PropTypes.array.isRequired
};

export default UsageTablePerMonth;
